import { TaxTypes } from "../enums";
import { taxLabels } from "../lang";
import type { Dataset, Datasets, FormOption, State } from "../types";

function sortByLabel(a: FormOption<unknown>, b: FormOption<unknown>) {
  if (a.label > b.label) {
    return 1;
  }

  if (a.label < b.label) {
    return -1;
  }

  return 0;
}

export function getStateOptions(datasets: Datasets): FormOption<State>[] {
  if (!datasets) {
    return [];
  }

  const states = [...datasets.states.entries()];
  return states.map(([label, value]) => ({ label, value })).sort(sortByLabel);
}

export function getRegionOptions(state: State): FormOption<Dataset>[] {
  if (!state) {
    return [];
  }

  const regions = [...state.regions.values()];

  return regions
    .map((region) => ({ label: region.name, value: region }))
    .sort(sortByLabel);
}

export function getYearOptions(datasets: Datasets): FormOption<number>[] {
  if (!datasets) {
    return [];
  }

  const years = [...datasets.years.values()];
  return years
    .map((year) => ({ label: String(year), value: year }))
    .sort(sortByLabel);
}

export function getTaxOptions(): FormOption<TaxTypes>[] {
  const taxes = Object.values(TaxTypes);
  return taxes.map((value) => ({ label: taxLabels[value], value }));
}
